import { useState, useEffect } from "react";
// import ClipLoader from "react-spinners/ClipLoader";
import DefaultStyles from "./DefaultStyles";
import PayButtonComponent from "./PayButtonComponent";
import { cleanUpContainer } from "../../utils/html";
import { CircularProgress } from "@mui/material";

const CardComponent = ({
  paymentIntent,
  onPaymentSuccess,
  onPaymentError,
  onRefreshPaymentIntent,
}) => {
  const [loading, setLoading] = useState(true);
  const [card, setCard] = useState(null);
  const [paymentInProgress, setPaymentInProgress] = useState(false);
  const [formComplete, setFormComplete] = useState(false);

  const containerId = "demo-payment";

  console.log("Rendering card component...", paymentIntent);

  useEffect(() => {
    if (paymentIntent != null) {
      console.log("Rendering card payment form iframe...", paymentIntent);

      // We need to do this in case or rerendering of the component
      // for example when error happened and client token was re-freshed.
      cleanUpContainer(containerId);
      setLoading(true);

      const config = {
        paymentDetails: {
          paymentToken: paymentIntent.clientSessionSecret,
        },
        containerId: containerId,
        fontCss: ["https://fonts.googleapis.com/css?family=Do+Hyeon"],
        styles: { ...DefaultStyles },
        onIframeLoaded: onCardPaymentFormLoaded,
        onIframeLoadFailed: onCardPaymentFormLoadFailed,
        callbacks: {
          onFormComplete: onFormComplete,
        },
        text:{
            cardName:{
                showValidation: true,
            },
            cardNumber:{
                showValidation: true,
            },
            expiryDate:{
                showValidation: true,
            },
            cv2:{
                showValidation: true,
            }

        }
      };

      setCard(new window.Dojo.Payment(config));
    }
  }, [paymentIntent]);

  function onPay() {
    console.log(`Payment request`);

    setPaymentInProgress(true);

    card
      .executePayment()
      .then(function (data) {
        console.log("Payment request result", data);
        // Check if success. Complete list of result codes: https://docs.dojo.tech/payments/accept-payments/components/configuration#status-code
        if (data && data.statusCode === 0) {
          onPaymentSuccess();
        } else {
          onPaymentError([
            "Payment failed. Please try again.",
            `Error: ${data.message}`,
          ]);
          onRefreshPaymentIntent();
        }
      })
      .catch(function (response) {
        console.log(
          "Payment request failed due to client side error: ",
          response
        );
        onPaymentError([response.message]);
      })
      .then(function () {
        setPaymentInProgress(false);
      });
  }

  function onCardPaymentFormLoaded() {
    setLoading(false);
  }

  function onCardPaymentFormLoadFailed() {
    setLoading(false);
  }

  function onFormComplete() {
    console.log("Form complete");
    setFormComplete(true);
  }

  return (
    <>
      {loading && (
        <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          {" "}
          <CircularProgress size={24} />
        </div>
      )}
      <div id={containerId} className="item" />

      <PayButtonComponent
        amountInMinorUnit={paymentIntent?.amount?.value}
        ready={!loading && !paymentInProgress}
        enabled={formComplete}
        onClick={onPay}
      />
    </>
  );
};

export default CardComponent;
